<template>
  <div class="zt-snail_5thSpecial">
    <!-- 活动标题 -->
    <div v-wechat-title="'最無厘頭放置手遊《最強蝸牛》'"></div>


    <div class="zt-snail_5thSpecial_box">
      <header class="snail-header" :class="'snail-header-login-' + headerLogin">
        <div class="user-info">
          <div>{{ user_info.role_name }}</div>
          <div>{{ user_info.server_name }}</div>
        </div>
        <a class="new-download-btn" title="官网" @click="goWebSite"></a>
        <a v-if="!user_info.role_id" class="new-logon-btn" @click="loginShow = true" title="登录&切换按钮"></a>
        <a v-if="user_info.role_id" class="new-logout-btn" @click="logoutShow = true"></a>
      </header>
      <div class="zt_snail_5thSpecial_page">
        <div class="big-title"></div>
        <div class="small-title"></div>
        <div class="fb-btn" @click="goLink">
        </div>

        <div class="video-btn" :class="{ playing: isPlaying }" @click="toggleMusic"></div>
        <!-- 背景音乐 -->
        <audio ref="bgMusic" loop>
          <source src="../../snail_5thLeading/index/snail.mp3" type="audio/mpeg" />
        </audio>
        <div class="content-01">
          <div class="rule-btn" @click="ruleShow = true"></div>
          <div class="qd-btn" :class="{ got: is_get }" @click="getReward"></div>
        </div>

        <div class="content-02"></div>


        <div class="content-03">

          <div class="tiehuan"></div>
          <!-- Tabs -->
          <img :src="currentTab === 0 ? tabImgs.active[0] : tabImgs.normal[0]" class="tab-btn tab-1"
            :class="{ 'tab-active': currentTab === 0 }" @click="switchTab(0)" />
          <img :src="currentTab === 1 ? tabImgs.active[1] : tabImgs.normal[1]" class="tab-btn tab-2"
            :class="{ 'tab-active': currentTab === 1 }" @click="switchTab(1)" />
          <img :src="currentTab === 2 ? tabImgs.active[2] : tabImgs.normal[2]" class="tab-btn tab-3"
            :class="{ 'tab-active': currentTab === 2 }" @click="switchTab(2)" />

          <!-- Arrows -->
          <img src="https://download4.qcplay.com/snail/snail_5thSpecial/left_arrow.png" class="arrow arrow-left"
            @click="slidePrev" />
          <img src="https://download4.qcplay.com/snail/snail_5thSpecial/right_arrow.png" class="arrow arrow-right"
            @click="slideNext" />

          <!-- Swiper Main Image -->
          <div class="main-image">
            <div class="swiper-container" ref="imageSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(img, index) in mainImages" :key="index">
                  <img :src="img" />
                </div>
              </div>
            </div>
          </div>

          <!-- Swiper Text Image -->
          <div class="text-block">
            <div class="swiper-container" ref="textSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(text, index) in textImages" :key="index">
                  <img :src="text" />
                </div>
              </div>
            </div>
          </div>

          <!-- Dots -->
          <div class="dots">
            <img v-for="(item, index) in tabImgs.normal" :key="index"
              :src="currentTab === index ? activeDot : normalDot"
              :class="['dot', { 'dot-active': currentTab === index }]" @click="switchTab(index)" />
          </div>
        </div>


        <div class="content-04">
        </div>

        <div class="content-06">
          <!-- 左箭头 -->
          <img src="https://download4.qcplay.com/snail/snail_5thSpecial/left_arrow.png" class="arrow arrow-left"
            @click="slidePrev1" />

          <!-- 右箭头 -->
          <img src="https://download4.qcplay.com/snail/snail_5thSpecial/right_arrow.png" class="arrow arrow-right"
            @click="slideNext1" />

          <!-- 主图 Swiper -->
          <div class="ts-main-image">
            <div class="swiper-container" ref="tsImageSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(img, index) in mainImages1" :key="index">
                  <img :src="img" />
                </div>
              </div>
            </div>
          </div>

          <!-- Dot 指示器 -->
          <div class="ts-dots">
            <img v-for="(dot, index) in mainImages1" :key="index"
              :src="currentSlide1 === index ? activeDot1 : normalDot1"
              :class="['dot', { 'dot-active': currentSlide1 === index }]" @click="goToSlide1(index)" />
          </div>
        </div>

        <div class="content-05">
          <div class="media-btn" @click="showMedia"></div>
        </div>


        <!-- 规则弹窗 -->
        <div :class="'rule-wrap popup_wrap rule-wrap-' + ruleShow" v-show="ruleShow">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
            :duration="{ enter: 1000 }">
            <div class="rule-box popup_wrap-box" v-show="ruleShow">
             
            </div>
          </transition>
          <div class="close-bg" @click="ruleShow = false"></div>
        </div>

        <!-- 注销弹窗 -->
        <div class="logout-wrap popup_wrap" v-show="logoutShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="logout-box popup_wrap-box" v-show="logoutShow">
              <p>是否退出當前帳號</p>
              <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
              <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
            </div>
          </transition>
        </div>

        <!-- 签到领取奖励弹窗 -->
        <div :class="'reward-wrap popup_wrap rule-wrap-' + rewardShow" v-show="rewardShow">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
            :duration="{ enter: 1000 }">
            <div class="reward-box popup_wrap-box" v-show="rewardShow">
              <div class="get-btn" @click="rewardShow = false"></div>
            </div>
          </transition>
          <div class="close-bg" @click="rewardShow = false"></div>
        </div>

        <div :class="'login-wrap popup_wrap login-wrap-' + loginShow" v-show="loginShow">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
            :duration="{ enter: 1000 }">
            <div class="login-box popup_wrap-box" v-show="loginShow">
              <div class="login_box">
                <input class="id-input" type="text" v-model="role_id" @keydown.space.prevent />
              </div>
              <div class="get-btn" @click="debounceLoginMethod"></div>
            </div>
          </transition>
          <div class="close-bg" @click="closeLogin"></div>
        </div>


        <div class="video_wrap new_popup_wrap" :class="{ active: mediaShow }">
          <div class="video_box_pop popup_box">
            <div class="popup_content">
              <iframe ref="mediaIframe" :src="videoSrc" frameborder="0" allowfullscreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                title="YouTube video player"></iframe>
            </div>

            <!-- 关闭按钮 -->
            <div class="close_wrapper btn" @click="hideMedia"></div>
          </div>
        </div>

      </div>
    </div>

    <div class="footer-wrapper swiper-slide slide-footer">

      <div class="footer-content zh_HK">
        <div class="top-content" style="margin-bottom: 15px">
          <p>
            <a target="_blank" href="https://law.snell.com.tw/zh-tw/service_agreement.html">服務條款</a>
            <a target="_blank" href="https://law.snell.com.tw/zh-tw/privacy_policy.html">隱私協議</a>
          </p>
        </div>

        <div class="bottom-content">
          <div class="l-logo" style="margin-right: 10px">
            <img src='https://download4.qcplay.com/qcgame-api/gPoRObLEHj6gH4Nttorxvu9j4z5bXnJ13ASABCat.png'>
          </div>
          <div class="r-text">
            <p>*思耐爾數位為最強蝸牛在台港澳的授權代理商。</p>
            <p>*本遊戲因涉及暴力、不當言語之情節，依遊戲軟體分級管理辦法分類為輔12級。</p>
            <p>*注意使用時間，避免沉迷於遊戲。</p>
            <p>*本遊戲為免費遊戲，但遊戲內另提供購買虛擬遊戲幣、物品等付費服務，請依個人興趣及能力適度消費。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils';
import { onGetToken, onGetUserInfo, onGetReward } from '../api'
import { Toast } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "snail_5thSpecial",
  components: {
  },

  data() {
    return {
      iosLink: [
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=eff77e8e-2884-4c32-9b7f-ae06d1ec4958',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=5df56eb4-ce75-4d5a-8d3f-48201fdaaee6',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=b96af72c-83ce-477a-b54d-a45417519219',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=b795d12c-f83e-465c-ad18-8f1fccf0b566',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=88a874ed-e219-4b0b-bf9f-ba8163bd08eb',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=90e211f0-ae90-41da-a61d-002c77c7991f',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=99a968ec-c8d1-4088-88e8-52b6c36a4dce',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=2583692c-47b6-4269-8e73-f9967c5aecd5',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=c15914f3-d595-43f9-9eb7-0079758bd424',
        'https://apps.apple.com/us/app/最強蝸牛/id1491859159?ppid=09be5958-0eaa-41cc-9d7c-a73496db43bb'
      ],
      gLink: [
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=1',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=2',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=3',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=4',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=5',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=6',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=7',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=8',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=9',
        'https://play.google.com/store/apps/details?id=com.ltgames.android.snail&listing=10'
      ],
      isPlaying: false, // 默认播放
      is_get: false,
      logoutShow: false,
      user_info: '',
      token: '',
      debounceLoginMethod: () => { }, // 不为null，避免绑定时报错
      headerLogin: false,
      loginShow: false,
      rewardShow: false, // 领取奖励弹窗 
      ruleShow: false,
      videoSrc: '',
      mediaShow: false,

      currentTab: 0,
      swiper2: null,
      swiper3: null,

      swiper1: null,
      currentSlide1: 0,
      mainImages1: [
        'https://download4.qcplay.com/qcgame-api/4K8rE3Dtr1naRj7miTVfRBEQauIm7x9RnU10eUiv.png',
        'https://download4.qcplay.com/qcgame-api/i79uAbSjHgIOto0OAKnRUcgq7vTZ8GmnukCHQErU.png',
        'https://download4.qcplay.com/qcgame-api/b1HZXrE75FgAJMej6gkvEcC5mZLyBMGYihYW7CJ2.png',
        'https://download4.qcplay.com/qcgame-api/DNAJ5MWhqhexf7dHmOYt1659VZFE7jXQE3VRfHHL.png',
        'https://download4.qcplay.com/qcgame-api/efDAZYux3Awp2m8hVZ7rLiLVAPGq05uaHUH8Bg1k.png',
        'https://download4.qcplay.com/qcgame-api/ztWoQvAZLEoUUf6i4Ll9I1EmDmRFiVUlxHPRgtcc.png'
      ],
      normalDot1: 'https://download4.qcplay.com/snail/snail_5thSpecial/dot.png',
      activeDot1: 'https://download4.qcplay.com/snail/snail_5thSpecial/active_dot.png',

      tabImgs: {
        normal: [
          'https://download4.qcplay.com/snail/snail_5thSpecial/tab1.png',
          'https://download4.qcplay.com/qcgame-api/Ckz8gtb2QzontQvhf3h8snr6nR0n9bE9FG8iWmk4.png',
          'https://download4.qcplay.com/snail/snail_5thSpecial/tab3.png',
        ],
        active: [
          'https://download4.qcplay.com/snail/snail_5thSpecial/tab1_active.png',
          'https://download4.qcplay.com/qcgame-api/PpHwAt1BvBcHW9JZQprk3rMhx0WEN5p5jDzh5WW0.png',
          'https://download4.qcplay.com/snail/snail_5thSpecial/tab3_active.png',
        ],
      },
      mainImages: [
        'https://download4.qcplay.com/snail/snail_5thSpecial/content_01.png',
        'https://download4.qcplay.com/snail/snail_5thSpecial/content_02.png',
        'https://download4.qcplay.com/snail/snail_5thSpecial/content_03.png',
      ],
      textImages: [
        'https://download4.qcplay.com/qcgame-api/ncJzUzBmPQTtUZYNPQ50CAJa7zUepWArD5ZxDgDQ.png',
        'https://download4.qcplay.com/qcgame-api/RjDyk473rX8vYql3ih5KZMFJDDKIdQar4opFuhIm.png',
        'https://download4.qcplay.com/qcgame-api/Bt4lX7H8hi6XxMXjMjcUZPKGTLSctzAhigWJeDw7.png',
      ],
      normalDot: 'https://download4.qcplay.com/snail/snail_5thSpecial/dot.png',
      activeDot: 'https://download4.qcplay.com/snail/snail_5thSpecial/active_dot.png',

      gameName: "snail",
      logger: null,
      // 轮播图图片
      role_id: '',
    };
  },
  created() {

  },
  mounted() {
    
    this.$nextTick(() => {
     this.autoRedirectToEnter()
      setTimeout(() => {
        this.playMusic()
        this.createDebouncedLogin();
        this.initSwiper1()
        this.initSwipers()
        if (window.localStorage.getItem('access_token')) {
          this.getTokenUserInfo(window.localStorage.getItem('access_token'))
        }

        // 埋点
        const bl = buriedLogger("snail", "蜗牛_港澳台五周年_专题页h5");
        this.logger = bl;
        setTimeout(() => {
          this.logger.sum("蜗牛_港澳台五周年_专题页统计");

          // 自定义统计日志
          this.logger.sum("蜗牛_港澳台五周年_专题页首页访问");
        }, 200);
      }, 100);
    });
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {

  },
  methods: {
    closeLogin() {
      this.loginShow = false
      this.role_id = ''
    },
    autoRedirectToEnter() {
      const { protocol, host, pathname, search } = window.location;
      const isMobile = /iphone|ipad|ipod|android/i.test(navigator.userAgent);

      // ✅ 移动端不处理
      if (isMobile) return;

      // ✅ 如果已经在 /enterxxxx/ 页面，就不要跳了（避免死循环）
      const isInEnterPage = /^\/snail_5thSpecial\/pc\d{4,}/.test(pathname);
      if (isInEnterPage) return;

      // ✅ 提取路径中第一个纯数字（支持任意位数）
      const pathParts = pathname.split('/');
      const xParam = pathParts.find(p => /^\d+$/.test(p));

      // ✅ 构造跳转路径
      const timestamp = Date.now();
      const newPath = `/snail_5thSpecial/pc${timestamp}${xParam ? `/${xParam}/` : '/'}`;
      const redirectUrl = `${protocol}//${host}${newPath}${search}`;

      // ✅ 跳转（不留历史记录）
      window.location.replace(redirectUrl);
    },
    playMusic() {
      const music = this.$refs.bgMusic;
      // 尝试播放音频
      music.play().then(() => {
        this.isPlaying = true;
      }).catch(() => {
        // 可能被浏览器拦截，处理权限请求或提示
        this.isPlaying = false;
      });
    },
    toggleMusic() {
      const music = this.$refs.bgMusic;
      if (this.isPlaying) {
        music.pause();
        this.isPlaying = false;
      } else {
        music.play();
        this.isPlaying = true;
      }
    },
    getReward() {
      if (!this.user_info.role_name) {
        this.loginShow = true
        return
      }
      if (this.is_get) return

      const isIOS = /iPhone|iPod|iOS/i.test(navigator.userAgent);
      const platform = isIOS ? 'ios' : 'and';
      const contentId = isIOS ? 'iossignin' : 'andsignin';
      // 平台特定事件
      window.fbq('track', `click_${contentId}`);
      window.gtag('event', `${platform}立即签到`);

      // 埋点
      window.qcq("track", "click", { "store": "android" });
      window.qcq("track", "click", { "store": "ios" });


      const { utm_source, utm_medium, utm_campaign, utm_content } = analysisParams(window.location.href);
      window.qcq("track", "book", {
        game_id: 120,
        utm_source: utm_source || '',
        utm_medium: utm_medium || '',
        utm_campaign: utm_campaign || '',
        utm_content: utm_content || '',
        os: !navigator.userAgent.match(/(iPhone|iPod|ios)/i) ? 'Android' : 'IOS',
      })

      onGetReward({ access_token: window.localStorage.getItem('access_token') })
        .then((response) => {
          if (response.code === 200) {
            this.logger.sum("蜗牛_港澳台五周年_专题页账号签到成功的次数");
            this.getTokenUserInfo(window.localStorage.getItem('access_token'))
            this.rewardShow = true
          }
        })
    },
    logoutBtn() {
      // 清空数据 控制弹窗
      window.localStorage.setItem("access_token", "");
      this.user_info = ''
      this.logoutShow = false
      this.headerLogin = false
      this.is_get = false
    },
    createDebouncedLogin() {
      let timer = null;
      let isFirstClick = true;

      // 返回包装函数
      this.debounceLoginMethod = () => {
        if (isFirstClick) {
          isFirstClick = false;
          this.loginMethod();
          return;
        }

        // 如果定时器存在，说明已点击，等待冷静期
        if (timer) {
          clearTimeout(timer);
        }

        // 设置防抖时间，例如 1000ms
        timer = setTimeout(() => {
          this.loginMethod();
          timer = null;
        }, 1000);
      };
    },

    loginMethod() {
      onGetToken({ game_id: 120, role_id: this.role_id })
        .then((response) => {
          if (response.code === 200) {
            this.token = response.data.access_token
            window.localStorage.setItem('access_token', response.data.access_token)
            this.getTokenUserInfo(this.token)
          } 
          Number(response.code) !== 401 && this.onToast(response.message);
        })
    },
    getTokenUserInfo(token) {
      if (!token) return
      onGetUserInfo({ access_token: token })
        .then((response) => {
          if (response.code === 200) {
            this.loginShow = false
            this.headerLogin = true
            this.role_id = ''
            this.user_info = response.data.userinfo
            this.is_get = response.data.activity.is_get
            this.logger.sum("蜗牛_港澳台五周年_专题页账号登录成功的次数");
          } 
        })
    },
    goWebSite() {
      window.location.href = 'https://snail.snell.com.tw/index_mobile.html?'
    },

    showMedia() {
      this.videoSrc = "https://www.youtube.com/embed/25S-bUjd910";
      this.mediaShow = true;
    },
    hideMedia() {
      this.mediaShow = false;
      this.videoSrc = ""; // 清除视频以停止播放
    },

    initSwipers() {
      this.swiper2 = new Swiper(this.$refs.imageSwiper, {
        loop: false,
        onSlideChangeEnd: () => {
          this.currentTab = this.swiper2.activeIndex;
          if (this.swiper3 && this.swiper3.activeIndex !== this.currentTab) {
            this.swiper3.slideTo(this.currentTab);
          }
        },
      });

      this.swiper3 = new Swiper(this.$refs.textSwiper, {
        loop: false,
        onSlideChangeEnd: () => {
          if (this.swiper2.activeIndex !== this.swiper3.activeIndex) {
            this.swiper2.slideTo(this.swiper3.activeIndex);
          }
        },
      });
    },
    switchTab(index) {
      this.currentTab = index;
      this.swiper2.slideTo(index);
      this.swiper3.slideTo(index);
    },
    slideNext() {
      if (this.currentTab < this.mainImages.length - 1) {
        this.switchTab(this.currentTab + 1);
      }
    },
    slidePrev() {
      if (this.currentTab > 0) {
        this.switchTab(this.currentTab - 1);
      }
    },


    initSwiper1() {
      this.swiper1 = new Swiper(this.$refs.tsImageSwiper, {
        loop: false,
        onSlideChangeEnd: () => {
          this.currentSlide1 = this.swiper1.activeIndex;
        },
      });
    },
    slideNext1() {
      const len = this.mainImages1.length;
      if (this.currentSlide1 < len - 1) {
        this.swiper1.slideTo(this.currentSlide1 + 1);
      }
    },
    slidePrev1() {
      if (this.currentSlide1 > 0) {
        this.swiper1.slideTo(this.currentSlide1 - 1);
      }
    },
    goToSlide1(index) {
      this.swiper1.slideTo(index);
    },

    handleLink() {
      const ua = navigator.userAgent.toLowerCase();
      const new_isIOS = /iphone|ipad|ipod/.test(ua);
      const new_isAndroid = /android/.test(ua);

      const defaultIOS = 'https://apps.apple.com/app/id1491859159';
      const defaultAndroid = 'https://play.google.com/store/apps/details?id=com.ltgames.android.snail';

      const path = window.location.pathname;
      const parts = path.split('/');
      const channelPart = parts.find(p => /^\d{1,2}$/.test(p)); // 找第一个纯数字（1-2位）

      const index = channelPart ? parseInt(channelPart, 10) : null;

      let url = '';

      if (index >= 1 && index <= 10) {
        url = new_isIOS ? this.iosLink[index - 1] : new_isAndroid ? this.gLink[index - 1] : '';
      } else {
        url = new_isIOS ? defaultIOS : new_isAndroid ? defaultAndroid : '';
      }

      if (url) {
        window.open(url, '_blank');
      }

      window.open(url, '_blank');
    },

    goLink() {
      const isIOS = /iPhone|iPod|iOS/i.test(navigator.userAgent);
      const platform = isIOS ? 'ios' : 'and';
      const contentId = isIOS ? 'iosshop' : 'andshop';
      // 平台特定事件
      window.fbq('track', `click_${contentId}`);
      window.gtag('event', `${platform}立即下载`);

      // 埋点
      window.qcq("track", "click", { "store": "android" });
      window.qcq("track", "click", { "store": "ios" });


      const { utm_source, utm_medium, utm_campaign, utm_content } = analysisParams(window.location.href);
      window.qcq("track", "book", {
        game_id: 120,
        utm_source: utm_source || '',
        utm_medium: utm_medium || '',
        utm_campaign: utm_campaign || '',
        utm_content: utm_content || '',
        os: !navigator.userAgent.match(/(iPhone|iPod|ios)/i) ? 'Android' : 'IOS',
      })


      this.handleLink()
    },

    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1500,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "onCount", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/snail_5thSpecial/index/index.vue